import { TextField } from '@mui/material';
import { Control, FieldError, Path, RegisterOptions, useController } from 'react-hook-form';

export type FormTextFieldProps<T> = {
    label: string;
    name: Path<T>;
    control: Control<T>;
    componentProps?: {
        type?: string;
        startAdornment?: JSX.Element;
        endAdornment?: JSX.Element;
    };
    rules?: Omit<RegisterOptions<T>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>;
    required?: boolean;
    fieldError?: FieldError;
    hidden?: boolean;
    disabled?: boolean;
    multiline?: boolean;
    rows?: number;
};

export function FormTextField<T>({
    label,
    name,
    control,
    componentProps = {},
    rules = {},
    fieldError,
    disabled,
    multiline,
    rows,
}: FormTextFieldProps<T>) {
    const {  field: { ref, ...inputProps }, } = useController({
        name,
        control,
        rules,
    });

    return (
        <TextField
            sx={{ width: 1 }}
            {...inputProps}
            disabled={disabled}
            type={componentProps?.type}
            inputRef={ref}
            error={!!fieldError}
            label={label + (!!rules.required ? ' *' : '')}
            helperText={fieldError?.message}
            InputProps={{
                startAdornment: componentProps?.startAdornment,
                endAdornment: componentProps?.endAdornment,
            }}
            multiline={multiline}
            rows={rows}
        />
    );
}
